







import { createComponent, computed } from '@vue/composition-api'
interface InitProps {
    iconClass: string
    className: string
}
function useExternal(path: string) {
    return /^(https?:|mailto:|tel:)/.test(path)
}
export default createComponent({
    name: 'SvgIcon',
    props: {
        iconClass: {
            type: String,
            required: true,
        },
        className: {
            type: String,
            default: '',
        },
    },
    setup(props: InitProps) {
        const isExternal = computed(() => {
            return useExternal(props.iconClass)
        })
        const iconName = computed(() => {
            return `#icon-${props.iconClass}`
        })
        const svgClass = computed(() => {
            if (props.className) {
                return 'svg-icon ' + props.className
            } else {
                return 'svg-icon'
            }
        })
        const styleExternalIcon = computed(() => {
            return {
                mask: `url(${props.iconClass}) no-repeat 50% 50%`,
                '-webkit-mask': `url(${props.iconClass}) no-repeat 50% 50%`,
            }
        })

        return {
            isExternal,
            iconName,
            svgClass,
            styleExternalIcon,
        }
    },
})
